export default {"src":"/_next/static/media/POT.39515f55.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};